import React from "react";

import {compact} from "@pg-mono/nodash";

import {IValueLabel} from "../../../variables/types/IValueLabel";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";

interface IProps {
    naturalSites: number[];
    naturalSitesTypes: IValueLabel[];
}

export const OfferDetailNaturalSites: React.FunctionComponent<IProps> = (props) => {
    const foundNaturalSitesTypes = compact(props.naturalSites.map((naturalSite) => findVariableByValue(props.naturalSitesTypes, naturalSite)));

    if (foundNaturalSitesTypes.length) {
        return <>{`w okolicy inwestycji znajduje się ${foundNaturalSitesTypes.map(({label}) => label).join(", ")}`}</>;
    }

    return null;
};
import React from "react";

import {compact} from "@pg-mono/nodash";

import {IValueLabel} from "../../../variables/types/IValueLabel";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";

interface IProps {
    naturalSites: number[];
    naturalSitesTypes: IValueLabel[];
}

export const OfferDetailNaturalSites: React.FunctionComponent<IProps> = (props) => {
    const foundNaturalSitesTypes = compact(props.naturalSites.map((naturalSite) => findVariableByValue(props.naturalSitesTypes, naturalSite)));

    if (foundNaturalSitesTypes.length) {
        return <>{`w okolicy inwestycji znajduje się ${foundNaturalSitesTypes.map(({label}) => label).join(", ")}`}</>;
    }

    return null;
};
